document.querySelector(':root').style.setProperty('--omc-chat-branding-header-background', '#58cfc3'); // Header background (opcional)
// document.querySelector(':root').style.setProperty('--omc-chat-branding-bubble-avatar-border', '#58cfc3'); // Avatar bubble border color (opcional)

 var omc_s0 = document.createElement("script");
 omc_s0.type = "text/javascript";
 omc_s0.src = "https://cdn.jsdelivr.net/npm/js-md5@0.7.3/build/md5.min.js";
 document.head.appendChild(omc_s0);
      
 var omc_s1 = document.createElement("script");
 omc_s1.type = "text/javascript";
 omc_s1.src = "https://chat.omnicommerce.app/webrocket.js";
 omc_s1.onload = () => {
   omc.init({
     publicKey: '194303b9ac', // Solicitar a soporte webrocket publicKey
     webchat: {
       publicKey: '7c58c1d8e1', // Solicitar a soporte webchat publicKey
       // style : { bottom : '90px' },
       preopen : { title : '¡Hola!', message : '¿En qué podemos ayudarte?', button : 'Hablemos.'}
     }, 
     callback : () => { console.log('Done injecting the chat window!') } // function: Se ejecutará tras iniciar Webrocket
   })
 }
 document.head.appendChild(omc_s1);
